import React, { useState, useEffect, memo } from 'react';
import { ChartRenderer } from './ChartRenderer.js';
import { ChartBox } from './charts/ChartBox.js';
import PosterLayout from './PosterLayout.js';

const ChartGridLayout = ({
  metrics,
  selectedCharts,
  onChartChange,
  chartData,
  filteredData,
  climbingStyle,
  gradeSystem,
  onGradeClick,
  chartLayouts,
  onLayoutChange,
  isPosterMode = false,
  lockedMode = null,
  onExitPosterMode,
  climberName,
  selectedYear
}) => {
  const [gridLayout, setGridLayout] = useState('single');
  
  useEffect(() => {
    if (!isPosterMode) {
      const updateLayout = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        
        if (width > 1024 && height > 1024) {
          setGridLayout('quad');
        } else if (width > 1024) {
          setGridLayout('dual');
        } else {
          setGridLayout('single');
        }
      };

      updateLayout();
      window.addEventListener('resize', updateLayout);
      return () => window.removeEventListener('resize', updateLayout);
    }
  }, [isPosterMode]);
  
  if (isPosterMode) {
    return (
      <PosterLayout
        selectedCharts={selectedCharts}
        filteredData={filteredData}
        climbingStyle={climbingStyle}
        gradeSystem={gradeSystem}
        onGradeClick={onGradeClick}
        chartLayouts={chartLayouts}
        lockedMode={lockedMode}
        onExitPosterMode={onExitPosterMode}
        climberName={climberName}
        selectedYear={selectedYear}
      />
    );
  }
  
  const renderChartBox = (position) => (
    <ChartBox
      key={`chart-${position}`}
      position={position}
      selectedMetric={selectedCharts[position]}
      onChartChange={onChartChange}
      metrics={metrics}
      chartData={chartData}
      filteredData={filteredData}
      climbingStyle={climbingStyle}
      gradeSystem={gradeSystem}
      onGradeClick={onGradeClick}
      chartLayouts={chartLayouts}
      onLayoutChange={onLayoutChange}
    />
  );

  const layouts = {
    single: renderChartBox(0),
    dual: (
      <div className="grid grid-cols-2 gap-2">
        {[0, 1].map(position => renderChartBox(position))}
      </div>
    ),
    quad: (
      <div className="grid grid-cols-2 gap-1">
        {[0, 1, 2, 3].map(position => renderChartBox(position))}
      </div>
    )
  };

  return layouts[gridLayout];
};

export default memo(ChartGridLayout);